import { createTheme, ThemeOptions } from '@mui/material';
import { ptBR } from '@mui/material/locale';
import { DEFAULT_FONT } from './font';

const theme: ThemeOptions = {
  palette: {
    primary: { main: '#005DD9', dark: '#0045B6', light: '#E6F7FF' },
    secondary: { main: '#0000008A', dark: '#000', light: '#1E1E1E' },
    success: { main: '#417505', light: '#C3E39E' },
    error: { main: '#B30303', light: '#FEA6A6' },
    warning: { main: '#F5A623', light: '#FFE2B1' },
    grey: { 400: '#333333', 300: '#666666', 200: '#999999', 100: '#CCCCCC' },
    black: { main: '#000000' },
  },
  typography: {
    fontFamily: DEFAULT_FONT,
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          color: '#333333',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#979797',
          ':hover': {
            color: '#005DD9',
          },
        },
      },
    },
  },
};

export default createTheme(theme, ptBR);
